module.exports = __webpack_public_path__ + "static/media/host-icon-red.8a20c38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/host-icon-red.png
// module id = 68
// module chunks = 0